import type { ImageProps as NextImageProps } from 'next/image';
import type {
  TransitionConfig,
  TransitionType,
} from '../../unlisted/scroll-transition/ScrollTransition.data';

export type ImageRef = HTMLDivElement;

export const defaultQuality = 75;
export const defaultLayout = 'responsive';
export const defaultPlaceholder = 'empty';
export const defaultLoading = 'eager'; // lazy
export const defaultObjectFit = 'cover';

// https://nextjs.org/docs/api-reference/next/image#required-props
export type ImageProps = {
  className?: string;
  innerClassName?: string;
  srcDesktop: string;
  layout?: 'fill' | 'fixed' | 'intrinsic' | 'responsive';
  objectFit?: React.CSSProperties['objectFit'];

  transition?: {
    type: TransitionType;
    config?: TransitionConfig;
    vars?: ScrollTrigger.Vars;
  };

  innerTransition?: {
    type: TransitionType;
    config?: TransitionConfig;
    vars?: ScrollTrigger.Vars;
  };

  alt?: string;
  style?: React.CSSProperties;
} & Omit<NextImageProps, 'objectFit' | 'alt'>;
